<script setup lang="ts">
import Banner from '../blocks/Banner.vue';
</script>

<template>
  <Banner status="warning">
    Clovyr does not have access to your Secret Key and cannot help recover it if you lose it.
  </Banner>
</template>
